module.exports = __webpack_public_path__ + "static/media/injures.e16bb8e7.svg";